import auth, { IConformForgotPassword } from '../services/auth';
import routes from '../constants/routes';
import routing from '../services/routing';

export default async (formData: IConformForgotPassword) => {
    await auth.confirmForgotPassword(formData);
    routing.push(routes.COMPLETE_FORGOT_PASSWORD);
};
